<template>
  <div class="campus-dropdown">
    <div class="col-3 field-label">{{label}}:</div>
    <div class="col-7 field-response">
        <div class="single-campus" v-if="values.length === 1">
          {{values[0].name}} <span class="special-info">(only available campus)</span>
        </div>
        <select v-model="currentValue" class="form-select inner-select" :disabled="elementDisabled" v-else>
            <option :value="null" v-show="currentValueDefined">Please Select Campus</option>
            <option :value="undefined" v-show="!currentValueDefined">Please Select Campus</option>
            <option v-for="val in values" :value="val.id" :key="val.id">{{val.name}}</option>
        </select>
    </div>
    <div class="col-2 field-error">
        {{errors}}
    </div>
  </div>
</template>

<script>
import PropsMixin from './FormElementPropsMixin'
import ComputedMixin from './FormElementComputedMixin'

export default {
  name: 'CampusDropDown',
  mixins: [PropsMixin, ComputedMixin],
  data () {
    return {
    }
  },
  computed: {
    values () {
      return this.currentProgram ? this.formField.formListItems.filter((campus) => !campus.program_ids || campus.program_ids.includes(this.currentProgram)) : this.formField.formListItems
    }
  },
  mounted () {
    if (this.values.length === 1) {
      this.currentValue = this.values[0].id
    }
  },
  watch: {
    values (newValue) {
      if (newValue.length === 1) {
        this.currentValue = newValue[0].id
      }
    }
  }
}
</script>
<style scoped>
.single-campus {
  padding-bottom: 10px;
}
</style>
